import Full from '@rebuild/materials/shared/leave_word/FullIndex.vue';
import Form from '@rebuild/materials/shared/leave_word/Form.vue';
import Result from '@rebuild/materials/shared/leave_word/Result.vue';

export const componentMap = {
	full: Full,
	form: Form,
	result: Result
};
